export enum PaginationKey {
  NeepAssignedClients = 'NeepAssignedClients',
  AllClients = 'AllClients',
  RegisteredClients = 'RegisteredClients',
}
